export default __webpack_public_path__ + "static/media/Rubric.55081536e0c6e078f5c367b8ae04ed7b.webp";